export const JbkPlanningRecordType = {
    'Admin. Use Permit': 'Admin. Use Permit',
    'Appeal': 'Appeal',
    'Condo Conversion Local Law Compliance': 'Condo Conversion Compliance',
    'Design Review': 'Design Review',
    'Landmarks Initiation': 'Landmarks Initiation',
    'Pre-Application': 'Pre-Application',
    'Structural Alteration Permit': 'Structural Alteration Permit',
    'Zoning Certificate': 'Zoning Certificate',
    'Zoning Permit': 'Zoning Permit',
    'Zoning Research Letter': 'Zoning Research Letter',
}

export const JbkPlanningFileType = {
    'Administrative Decision': 'Administrative Decision',
    'Administrative Use Permit': 'Administrative Use Permit',
    'Application': 'Application',
    'Commission Submittal': 'Commission Submittal',
    'Environmental': 'Environmental',
    // 'Correspondence': 'Correspondence',
    // 'Notification': 'Notification',
    'Opposition Letter': 'Opposition Letter',
    'Other Planning Staff Document': 'Other Planning Staff Document',
    // 'Photographs': 'Photographs',
    'Plans': 'Plans',
    'Technical Reports': 'Technical Reports',
    'ZAB Decisions': 'ZAB Decisions',
}

export const JbkPlanningAdminFileType = {
    'Application': 'Application',
    'Environmental': 'Environmental',
    'Commission Submittal': 'Commission Submittal',
    'Administrative Decision': 'Administrative Decision',
    'Administrative Use Permit': 'Administrative Use Permit',
    'ZAB Decisions': 'ZAB Decisions',
    'Correspondence': 'Correspondence',
    'Map': 'Map',
    'Notification': 'Notification',
    'Other Planning Staff Document': 'Other Planning Staff Document',
    'Opposition Letter': 'Opposition Letter',
    'Photographs': 'Photographs',
    // 'CE-General-NOV-Issued': 'CE-General-NOV-Issued',
    // 'PLN-EMAIL NOTIFICATION': 'PLN-EMAIL NOTIFICATION',
    'Planning Approval Letter': 'Planning Approval Letter',
    'Plans': 'Plans',
    // 'Supplemental Forms': 'Supplemental Forms',
    'Letters of Determination': 'Letters of Determination',
    'Technical Reports': 'Technical Reports',
    'Zoning Verification Letters': 'Zoning Verification Letters',
    'Other': 'Other',
}

export const JbkZones = {
    'C-1': 'C-1',
    'C-AC': 'C-AC',
    'C-DMU Buff': 'C-DMU Buff',
    'C-DMU Core': 'C-DMU Core',
    'C-DMU Corr': 'C-DMU Corr',
    'C-DMU Oute': 'C-DMU Oute',
    'C-E': 'C-E',
    'C-N': 'C-N',
    'C-N(H)': 'C-N(H)',
    'C-NS': 'C-NS',
    'C-NS(H)': 'C-NS(H)',
    'C-SA': 'C-SA',
    'C-SO': 'C-SO',
    'C-T': 'C-T',
    'C-W': 'C-W',
    'ES-R': 'ES-R',
    'M': 'M',
    'MM': 'MM',
    'MULI': 'MULI',
    'MUR': 'MUR',
    'R-1': 'R-1',
    'R-1A': 'R-1A',
    'R-1H': 'R-1H',
    'R-2': 'R-2',
    'R-2A': 'R-2A',
    'R-2AH': 'R-2AH',
    'R-2H': 'R-2H',
    'R-3': 'R-3',
    'R-3H': 'R-3H',
    'R-4': 'R-4',
    'R-4H': 'R-4H',
    'R-5': 'R-5',
    'R-5H': 'R-5H',
    'R-S': 'R-S',
    'R-SH': 'R-SH',
    'R-SMU': 'R-SMU',
    'SP': 'SP',
    'U': 'U',
    'X': 'X',
}

export const JbkGpClassifications = {
    'BC': 'BC',
    'DT': 'DT',
    'HDR': 'HDR',
    'I': 'I',
    'LDR': 'LDR',
    'M': 'M',
    'MDR': 'MDR',
    'MU': 'MU',
    'NC': 'NC',
    'OS': 'OS',
    'RMU': 'RMU',
    'W': 'W',
    'X': 'X',
}

export const DistanceMile = [
    {value: "0", display: "Any distance"},
    {value: "0.125", display: "Within 1/8 mile"},
    {value: "0.25", display: "Within 1/4 mile"},
    {value: "0.5", display: "Within 1/2 mile"},
    {value: "0.75", display: "Within 3/4 mile"},
    {value: "1.0", display: "Within 1 mile"},
    {value: "1.25", display: "Within 1 1/4 miles"},
    {value: "1.5", display: "Within 1 1/2 miles"},
    {value: "1.75", display: "Within 1 3/4 miles"},
    {value: "2", display: "Within 2 miles"},
    {value: "2.5", display: "Within 2 1/2 miles"},
    {value: "3", display: "Within 3 miles"},
    {value: "3.5", display: "Within 3 1/2 miles"},
    {value: "4", display: "Within 4 miles"},
    {value: "4.5", display: "Within 4 1/2 miles"},
    {value: "5", display: "Within 5 miles"},
    {value: "5.5", display: "Within 5 1/2 miles"},
    {value: "6", display: "Within 6 miles"},
    {value: "7", display: "Within 7 miles"},
    {value: "8", display: "Within 8 miles"},
    {value: "9", display: "Within 9 miles"},
]

export const JbkRecordStatus = {
    'Open': 'open',
    'Closed/completed': 'closed',
    'Withdrawn': 'withdrawn',
}